// TenantList.tsx
import React, { useMemo, useCallback } from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DataTable, { Column } from '../table/DataTable';
import { Box } from "@mui/material";
import TenantActionsMenu from './TenantActionMenu';
import { Client } from '../../apis/tenantApi/tenantApi';
/*export interface Client {
  id: string;
  template: string;
  zone: string;
  tenantName: string;
  tenantSize: number;
  services: string[];
}*/


interface TenantListProps {
  tenants: Client[];
  loading?: boolean;
}

const TenantList: React.FC<TenantListProps> = ({ tenants, loading = false }) => {
  const navigate = useNavigate();

  const handleView = useCallback(
    (clientId: number) => {
      navigate(`/tenants/view/${clientId}`);
    },
    [navigate]
  );

  const columns: Column<Client>[] = useMemo(
    () => [
      /*{ header: "Template", key: "template" },
      { header: "Zone", key: "zone" },
      { header: "Client Name", key: "tenantName" },
      { header: "Client Size", key: "tenantSize" },
      {
        header: "Services",
        key: "services",
        render: (value: string[]) =>
          Array.isArray(value) ? value.join(", ") : value,
      },
      {
        header: "Actions",
        key: "id",
        render: (_: any, row: Client) => (
          <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
            <Button onClick={() => handleView(row.id)}>View</Button>
          </Box>
        ),
      },*/

      { header: "Client Id", key: "clientId" },
      //{ header: "Template Id", key: "clientEnvConfigId" },
      { header: "Client Name", key: "clientName" },
      // {
      //   header: "Template Name",
      //   key: "clientConfigUrl",
      //   render: (value: string[]) =>
      //     Array.isArray(value) ? value.join(", ") : value,
      // },
      // {
      //   header: "Services",
      //   key: "services",
      //   render: (value: string[]) =>
      //     Array.isArray(value) ? value.join(", ") : value,
      // },
      // { header: "Zone", key: "zone" },
      {
        header: "Actions",
        key: "clientId",
        render: (_: any, row: Client) => <TenantActionsMenu tenant={row} />,
      }
    ],
    [handleView]
  );

  if (!Array.isArray(tenants)) {
    console.error(
      "Expected tenants to be an array, but received:",
      tenants
    );
    tenants = [];
  }

  return <DataTable columns={columns} data={tenants} loading={loading} />;
};

export default TenantList;
